<dashboardnav>
  
    <cradua-land-use-status
    [landusestatuss]="landusestatuss$ | async"
    (landusestatus)="onSubmitLandUseStatus($event)"
    (deleteLandUseStatusEvent)="onDeleteLandUseStatus($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-land-use-status>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  